<template>
  <member-list
    gender="female"
    title-key="memberList.femaleTitle"
  />
</template>

<script>
import MemberList from "../../components/MemberList.vue";

export default {
  name: "Female",
  components: {
    MemberList
  },
  created() {
    this.$parent.footer("female", true);
  },
  mounted() {
    if (localStorage.getItem("token") === null) {
      this.$router.push("/login");
    }
  }
};
</script>
